import {Component, inject, Input, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {ReactiveFormsModule, UntypedFormGroup} from '@angular/forms';
import {SelectButton} from 'primeng/selectbutton';

@Component({
  selector: 'app-player-profile-settings-item',
  imports: [
    SelectButton,
    ReactiveFormsModule
  ],
  templateUrl: './player-profile-settings-item.component.html',
  styleUrl: './player-profile-settings-item.component.scss'
})
export class PlayerProfileSettingsItemComponent implements OnInit
{
  private translate = inject(TranslateService);

  @Input() fieldName: string;
  @Input() form: UntypedFormGroup;

  stateOptions: any[];

  ngOnInit(): void
  {
    this.stateOptions = [
      {label: this.translate.instant('OFF'), value: 0},
      {label: this.translate.instant('ON'), value: 1}
    ];
  }
}
